import { gql } from 'graphql-request';
import {
  Nullable,
  UserWithToken,
  WithData,
} from '@ygoargentina/sdk/api/api.types';
import { getGraphQLQueryClient } from './query-client';

export type StickerAction = 'INSTALL' | 'REMOVE';

export type StickerOutcome = 'SUCCESS' | 'CANCELLED' | 'INVALID' | 'FAILED';

export type StickerEventInput = {
  action: StickerAction;
  outcome: StickerOutcome;
  /** `pack-<timestamp>` si lo armó la persona, el id del pack oficial si no. */
  packIdentifier: string;
  officialPackId?: Nullable<string>;
  reinstall?: boolean;
  stickerCount?: number;
  missingCount?: number;
  reason?: Nullable<string>;
  platform?: Nullable<string>;
};

/** Pública: `user` sólo sirve para que la fila quede con quién fue. */
export const trackStickerEvent = (
  user: Nullable<UserWithToken>,
  input: StickerEventInput
) =>
  getGraphQLQueryClient(user).request<WithData<boolean>>(
    gql`
      mutation trackStickerEvent($input: StickerEventInput!) {
        data: trackStickerEvent(input: $input)
      }
    `,
    { input }
  );
